import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  value: 0,
};

export const refetchAgendaListSlice = createSlice({
  name: 'refetchAgendaList',
  initialState,
  reducers: {
    incrementRefetchAgendaList: (state) => {
      state.value += 1;
    },
  },
});

export const { incrementRefetchAgendaList } = refetchAgendaListSlice.actions;

export default refetchAgendaListSlice.reducer;
